import * as dimensions from './dimensions.json'
import * as metrics from './metrics.json'
import * as datasources from './datasources.json'

window.metrics = metrics

export { dimensions, metrics, datasources }